import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

export const jobsAdapter = createEntityAdapter({
  selectId: (job) => job.uid,
  // Keep the "all IDs" array sorted based on job id
  // sortComparer: (a, b) => a.uid.localeCompare(b.uid),
})

export const jobsSlice = createSlice({
  name: 'jobs',
  initialState: jobsAdapter.getInitialState({
    editedJob: null,
  }),
  reducers: {
    jobAdded: jobsAdapter.addOne,
    jobUpdated: jobsAdapter.updateOne,
    jobRemoved: jobsAdapter.removeOne,
    jobCleared: jobsAdapter.removeAll,
    setEditedJob: (state, { payload }) => {
      state.editedJob = payload
    },
  },
})

export const jobsActions = jobsSlice.actions
